import {ChangeDetectorRef, Component, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { Observable } from 'rxjs';
import { finalize, catchError, flatMap } from 'rxjs/operators';
import { Dialog } from 'primeng/primeng';

import { AppBannerMsgComponent } from '../../app-banner-msg/app-banner-msg.component';
import { StepComponent } from './step.component';
import { DetermineCurrentRealityComponent } from './envisioning/determine-current-reality/determine-current-reality.component';
import { SynthesizeResultsComponent } from './envisioning/synthesize-results/synthesize-results.component';
import { DeliverablesComponent} from './deliverables/deliverables.component';
import { StrategiesPermissionsService } from '../services/strategies-permissions.service';
import { IStrategyPermissions } from '../../models/IStrategyPermissions';
import { StrategyService } from '../services/strategy.service';
import { PlanService } from '../services/plan.service';
import { IPlanTree } from '../services/IPlanTree';
import { PlanStep } from '../services/PlanStep';
import { IPurposeMissionBeliefs } from '../services/IPurposeMissionBeliefs';
import { StrtPriority } from '../../shared/models/plan/StrtPriority';
import { PriorityService } from '../services/priority.service';
import { StrtObjective } from '../../shared/models/plan/StrtObjective';
import { CustomerService } from '../../auth/services/customer.service';
import { DesignImplementationPlanComponent } from './implementing/design-implementation-plan/design-implementation-plan.component';
import { EnactMonitorProgressComponent } from './implementing/enact-monitor-progress/enact-monitor-progress.component';
import { StrtInitiative } from '../../shared/models/plan/StrtInitiative';
import { InitiativeService } from '../services/initiative.service';
import { StrtKeyMeasure } from '../../shared/models/plan/StrtKeyMeasure';
import { OutcomeImpactComponent } from './evaluating/outcome-impact/outcome-impact.component';
import { StrtActivityDates} from '../services/activity.service';
import { PlanCoordinate } from '../services/plan-coordinate';
import { ResourceService } from '../services/resource.service';
import { MainContentComponent } from '../../app-push-aside-content/main-content/main-content.component';
import { IResource, IUserGuide } from '../services/IResource';
import { DevelopAnnualPlanComponent } from './planning/develop-annual-plan/develop-annual-plan.component';
import { DevelopStrategyMapComponent } from './planning/develop-strategy-map/develop-strategy-map.component';
import {
  CreatingObjectivesCriticalInitiativesComponent
} from './planning/creating-objectives-critical-initiatives/creating-objectives-critical-initiatives.component';
import {
  IdentifyingOutcomesKeyMeasuresComponent
} from './planning/identifying-outcomes-key-measures/identifying-outcomes-key-measures.component';
import { StrtOutcome } from '../../shared/models/plan/StrtOutcome';
import { ExploreTheFutureComponent } from './envisioning/explore-the-future/explore-the-future.component';
import { ToastService } from '../../shared/services/toast.service';
import { AppLoadingService } from '../../app-loading-panel/app-loading.service';
import * as _ from 'lodash';
import {Observable} from 'rxjs/index';
import {StrategiesDataStoreService} from '../../shared/services/strategies-data-store.service';

@Component({
  selector: 'app-plan',
  templateUrl: './plan.component.html',
  styleUrls: ['./plan.component.scss']
})
export class PlanComponent implements OnInit, OnChanges {
  @ViewChild(MainContentComponent) mainContentComp: MainContentComponent;
  @ViewChild(AppBannerMsgComponent) private bannerMsgComp: AppBannerMsgComponent;
  /** Envisioning SubPhase Items **/
  @ViewChild(SynthesizeResultsComponent) synthesizeResultsComp: StepComponent<StrtPriority>;
  @ViewChild(ExploreTheFutureComponent) exploreTheFutureComp: StepComponent<StrtPriority>;
  @ViewChild(DetermineCurrentRealityComponent) determineCurrentRealityComp: StepComponent<StrtPriority>;
  /** END Envisioning SubPhase Items **/
  @ViewChild(DesignImplementationPlanComponent) designImplementationPlanComp: StepComponent<StrtActivityDates>;
  @ViewChild(EnactMonitorProgressComponent) enactMonitorProgressComp: StepComponent<void>;
  @ViewChild(OutcomeImpactComponent) outcomeImpactComponent: StepComponent<IResource>;
  @ViewChild(DeliverablesComponent) deliverablesComp: StepComponent<void>;
  @ViewChild(DevelopAnnualPlanComponent) developAnnualPlanComp: StepComponent<void>;
  @ViewChild(DevelopStrategyMapComponent) developStrategyMapComp: StepComponent<void>;
  @ViewChild(CreatingObjectivesCriticalInitiativesComponent) creatingObjectivesCriticalInitiativesComp:
    StepComponent<StrtObjective|StrtInitiative>;
  @ViewChild(IdentifyingOutcomesKeyMeasuresComponent) identifyOutcomesKeyMeasuresComp: StepComponent<StrtOutcome|StrtKeyMeasure>;
  @ViewChild('confirmDialog') private confirmDialog: Dialog;

  private _strategyId: number;
  private _planCoordinate: PlanCoordinate;
  private _planTree: IPlanTree;

  permissions: IStrategyPermissions;
  purposeMissionBeliefs: IPurposeMissionBeliefs;
  resources: IResource[] = [];
  impact: string;
  private _userGuides: IUserGuide[] = [];


  isPreventDeliverablePrompt: boolean;
  isPlanNavVisible = true;
  isNextStepsVisible = true;
  isLoading$: Observable<boolean>;

  dummy = false;

  appHeaderLeftAction = {
    icon: 'icon-arrow-left',
    action: () => this.router.navigate([`/strategies/dashboard/${this.customerService.institution.id}`]),
    tooltip: 'Back to dashboard'
  };


  constructor(private route: ActivatedRoute,
              private router: Router,
              private permissionService: StrategiesPermissionsService,
              private planService: PlanService,
              private customerService: CustomerService,
              private strategyService: StrategyService,
              private resourceService: ResourceService,
              private priorityService: PriorityService,
              private initiativeService: InitiativeService,
              private cdr: ChangeDetectorRef,
              private toastService: ToastService,
              private _strtDataStore: StrategiesDataStoreService,
              private appLoading: AppLoadingService) { }

  ngOnInit() {
    this.isLoading$ = this.appLoading.isLoading$;
    this._strtDataStore.reset();
    this.resourceService.userGuides$.subscribe((guides: IUserGuide[]) => {
      this._userGuides = guides;
      console.log(`Updated Plan User Guides`);
    });
    this.route.data.subscribe(data => {
      this.permissions = this.permissionService.userInstitutionPermissions;
      this._strategyId = data.strategyId;
      this.planTree = data.planTree;
      data.purposeMissionBeliefs.priorities = _.orderBy(data.purposeMissionBeliefs.priorities, ['sort'], ['asc']);
      this.purposeMissionBeliefs = data.purposeMissionBeliefs;
      this.initializePlanCoordinate(data.planCoordinate);
    });
    this.strategyService.isPreventDeliverablePrompt(this.strategyId).subscribe(it => this.isPreventDeliverablePrompt = it);
  }

  ngOnChanges(changes: SimpleChanges) {
    StepComponent.logNgOnChanges(changes);
  }

  get planTree(): IPlanTree {
    return this._planTree;
  }


  guideUrlForStep(planStep: PlanStep) {
    const stepName = this.planStepName(planStep);
    if (this._userGuides) {
      const guide: IUserGuide = this._userGuides.find((userGuide: IUserGuide) => {
        return userGuide.stepValue === stepName;
      });
      const guideUrl = guide ? `${this.resourceService.resourceBaseUrl}/${guide.userGuide.resourcePath}` : null;
      return guideUrl;
    }
  }

  planStepName(planStep) {
    let output: string;
    switch (planStep) {
      case PlanStep.ASSIGN_AND_COMMUNICATE_RESPONSIBILITIES:
        output = 'ASSIGN_AND_COMMUNICATE_RESPONSIBILITIES';
        break;
      case PlanStep.CREATE_OBJECTIVES_AND_CRITICAL_INITIATIVES:
        output = 'CREATE_OBJECTIVES_AND_CRITICAL_INITIATIVES';
        break;
      case PlanStep.DETERMINE_IMPACT_OF_CRITICAL_INITIATIVES:
        output = 'DETERMINE_IMPACT_OF_CRITICAL_INITIATIVES';
        break;
      case PlanStep.DEVELOP_STRATEGY_MAP:
        output = 'DEVELOP_STRATEGY_MAP';
        break;
      case PlanStep.ENACT_AND_MONITOR_PROGRESS:
        output = 'ENACT_AND_MONITOR_PROGRESS';
        break;
      case PlanStep.IDENTIFY_OUTCOMES_AND_KEY_MEASURES:
        output = 'IDENTIFY_OUTCOMES_AND_KEY_MEASURES';
        break;
      case PlanStep.SYNTHESIZE_RESULTS:
        output = 'SYNTHESIZE_RESULTS';
        break;
      case PlanStep.ADDRESS_IMPLICATIONS_FOR_FUTURE_WORK:
        output = 'ADDRESS_IMPLICATIONS_FOR_FUTURE_WORK';
        break;
      case PlanStep.DESIGN_THE_IMPLEMENTATION_PLAN:
        output = 'DESIGN_THE_IMPLEMENTATION_PLAN';
        break;
      case PlanStep.DETERMINE_CURRENT_REALITY:
        output = 'DETERMINE_CURRENT_REALITY';
        break;
      case PlanStep.DEVELOP_THE_ANNUAL_PLAN:
        output = 'DEVELOP_THE_ANNUAL_PLAN';
        break;
      case PlanStep.EXPLORE_THE_FUTURE:
        output = 'EXPLORE_THE_FUTURE';
        break;
      case PlanStep.JUDGE_SUCCESS_OF_ANNUAL_PLAN:
        output = 'JUDGE_SUCCESS_OF_ANNUAL_PLAN';
        break;
    }
    return output;
  }

  set planTree(planTree: IPlanTree) {
    this._planTree = planTree;
    this.resourceService.fetchUserGuides();
  }

  // TODO return this property to private scope
  get strategyId() {
    return this._strategyId;
  }

  get planCoordinate() {
    return this._planCoordinate;
  }

  get priorities() {
    return this.purposeMissionBeliefs ? this.purposeMissionBeliefs.priorities : [];
  }

  get isStepComplete() {
    return this.getStep().complete;
  }

  get isCompleteSwitchVisible() {
    return this.permissions.canEditBody && this.getStep().isCompletable;
  }

  isPreviousStepVisible() {
    return !this.planCoordinate.isEqual(this.previousPlanCoordinate);
  }

  isNextStepVisible() {
    return !this.planCoordinate.isEqual(this.nextPlanCoordinate);
  }

  // fired by the plan nav
  onPlanCoordinateClick(planCoordinate: PlanCoordinate) {
    const step = this.getStep(planCoordinate);
    if (step.isGuide) {
      const url = this.guideUrlForStep(step.planStep);
      window.open(url, '_blank');
    } else {
      this.initializePlanCoordinate(planCoordinate);
    }
  }

  onPlanCoordinateChange(planCoordinate: PlanCoordinate) {
    this.initializePlanCoordinate(planCoordinate);
  }

  onConfirmDialogAccept() {
    if (this.isPreventDeliverablePrompt) {
      this.strategyService.setPreventDeliverablePrompt(this.strategyId)
        .pipe(finalize(() => this.confirmDialog.visible = false),
              catchError(this.onError('onConfirmDialogAccept')))
        .subscribe();
    } else {
      this.confirmDialog.visible = false;
    }
  }

  onToggleStepComplete() {
    this.planService.toggleStepComplete(this.planTree, this.planCoordinate, this.strategyId)
      .subscribe(it => {
        console.log(`On Toggle Step Complete Response: ${JSON.stringify(it)}`);
          this.planTree = it;
        }, this.onError('onToggleStepComplete')
      );
  }

  onClickNextStep() {
    const adjacentStepCoordinate = this.nextPlanCoordinate;
    this.confirmDialog.visible = !this.isPreventDeliverablePrompt && (this.planCoordinate.planDomain !== adjacentStepCoordinate.planDomain);
    this.onPlanCoordinateClick(adjacentStepCoordinate);
  }

  onClickPreviousStep() {
    const adjacentStepCoordinate = this.previousPlanCoordinate;
    this.confirmDialog.visible = false; // the dialog should never be shown when going in reverse
    this.onPlanCoordinateClick(adjacentStepCoordinate);
  }

  // =========================================================================+

  onUpdatePurpose(purpose) {
    this.purposeMissionBeliefs.purpose = purpose;
    this.strategyService.updatePurpose(this.strategyId, this.purposeMissionBeliefs.purpose)
      .pipe(catchError(this.onError('onUpdatePurpose')))
      .subscribe();
  }

  onUpdateMission(mission) {
    this.purposeMissionBeliefs.mission = mission;
    this.strategyService.updateMission(this.strategyId, this.purposeMissionBeliefs.mission)
      .pipe(catchError(this.onError('onUpdateMission')))
      .subscribe();
  }

  onUpdateBeliefs(beliefs) {
    this.purposeMissionBeliefs.beliefs = beliefs;
    this.strategyService.updateBeliefs(this.strategyId, this.purposeMissionBeliefs.beliefs)
      .pipe(catchError(this.onError('onUpdateBeliefs')))
      .subscribe();
  }

  // ==========================================================================

  onPriorityCreate(priority: StrtPriority) {
    this.priorityService.createPriority(this.strategyId, priority)
      .subscribe(it => {
        this.purposeMissionBeliefs.priorities = _.orderBy(it, ['sort'], ['asc']);
      }, (err) => {
        this.onError('onPriorityCreate');
      });
  }

  onPriorityEdit(priority: StrtPriority) {
    this.priorityService.updatePriority(this.strategyId, priority)
      .subscribe(priorities => {
        this.purposeMissionBeliefs.priorities = _.orderBy(priorities, ['sort'], ['asc']);
      }, (err) => {
        this.onError('onPriorityEdit');
      });
  }

  onPriorityDelete(priority: StrtPriority) {
    this.priorityService.deletePriority(this.strategyId, priority.priorityId)
      .subscribe(() => this.purposeMissionBeliefs.priorities =
          this.purposeMissionBeliefs.priorities.filter(it => it.priorityId !== priority.priorityId),
      this.onError('onPriorityDelete'));
  }

  onPriorityError(error: Error) {
    this.onError('onPriorityError')(error);
  }

  // ==========================================================================

  // TODO: See if we can get rid of this
  onObjectiveOrInitiativeError(error: Error) {
    this.onError('onObjectiveOrInitiativeError')(error);
  }

  // ==========================================================================

  onTrackInitiative(initiative: StrtInitiative) {
    if (initiative.initiativeStatus === null && !initiative.trackingToolsEnabled) {
      this.initiativeService.updateInitiativeStatus(initiative)
      .pipe(flatMap(() =>
        this.initiativeService.trackInitiative(initiative)
      ), catchError(this.onError('onUpdateInitiativeStatus'))).subscribe();
    } else {
      this.initiativeService.trackInitiative(initiative)
      .pipe(catchError(this.onError('onTrackInitiative'))).subscribe();
    }
  }

  onUpdateInitiativeStatus(initiative: StrtInitiative) {
    this.initiativeService.updateInitiativeStatus(initiative)
      .pipe(catchError(this.onError('onUpdateInitiativeStatus'))).subscribe();
  }

  // ==========================================================================

  onUpdateImpact(impact) {
    this.impact = impact;
    this.strategyService.updateImpact(this.strategyId, this.impact)
      .pipe(catchError(this.onError('onUpdateImpact'))).subscribe();
  }

  onResourceDelete(resource: IResource) {
    this.appLoading.setLoading();
    this.resourceService.deleteResource(resource.resourceId)
      .subscribe(() => {
        this.resourceService.getResources(this.strategyId);
        this.appLoading.clearLoading();
        }, (err) => {
        this.onError('onResourceDelete');
        this.appLoading.clearLoading();
      });
  }

  // ==========================================================================

  private get nextPlanCoordinate() {
    return this.planTree.getNextPlanCoordinate(this.planCoordinate);
  }

  private get previousPlanCoordinate() {
    return this.planTree.getPreviousPlanCoordinate(this.planCoordinate);
  }

  private getStep(planCoordinate: PlanCoordinate = this.planCoordinate) {
    return this.planTree.getStep(planCoordinate);
  }

  get PlanStep() {
    return PlanStep;
  }

  private initializePlanCoordinate(planCoordinate: PlanCoordinate, preventScroll = false) {
    if (!planCoordinate) {
      console.error('initializePlanCoordinate planCoordinate: ', planCoordinate);
    } else {
      this.updateNextStepsVisibility(planCoordinate);
      this._planCoordinate = planCoordinate; // TODO persist the step for the plan
    }
    if (this.mainContentComp && !preventScroll) {
      this.mainContentComp.scrollToTop();
    }
    this.cdr.detectChanges();
  }

  private updateNextStepsVisibility(planCoordinate: PlanCoordinate) {
    this.isNextStepsVisible = !(planCoordinate.planStep === PlanStep.OUTPUTS);
  }

  private onError(logPrefix) {
    return (error: Error) => {
      console.error(logPrefix, error);

      if (!this.dummy) {
        this.toastService.queueErrorToastWithMessage(error.message);
      } else {
        this.bannerMsgComp.addErrorMessage(error.message);
      }
      return null;
    };
  }

  refetchPurposeMissionBeliefs(strategyId: number) {
    this.planService.getPurposeMissionBeliefs(strategyId).subscribe((pmb: IPurposeMissionBeliefs) => {
      pmb.priorities = _.orderBy(pmb.priorities, ['sort'], ['asc']);
      this.purposeMissionBeliefs = pmb;
    });
  }

  reloadSynthesizeResults(coord: PlanCoordinate) {
    this.refetchPurposeMissionBeliefs(this.strategyId);
    this.initializePlanCoordinate(coord, true);
  }

  reloadCreateObjectivesCriticalInitiatives(coord: PlanCoordinate) {
    this.initializePlanCoordinate(coord, true);
  }

}
